import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function HamburgerMenuIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <title>Show Menu</title>
      <path
        d="M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
        transform="translate(-335.000000, -23.000000) translate(335.000000, 23.000000)"
      />
    </SvgIcon>
  );
}

export default HamburgerMenuIcon;
